import { render, staticRenderFns } from "./icon-api-integration.vue?vue&type=template&id=c6333b0a&scoped=true&"
import script from "./icon-api-integration.vue?vue&type=script&lang=js&"
export * from "./icon-api-integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6333b0a",
  null
  
)

export default component.exports